import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@repo/core";
import type { PasswordResetPayload } from "@repo/core";

/**
 * Unauthenticated auth-flow mutations (password reset request).
 *
 * Hits the ANP host through `apiClient` with auth deliberately skipped —
 * nobody is signed in when this runs. Like the profile mutations, the hook
 * neither toasts nor navigates: the backend distinguishes "unknown e-mail"
 * (401) from validation errors, and the form renders each differently.
 */

export const useRequestPasswordReset = () =>
    useMutation<{ detail?: string }, Error, PasswordResetPayload>({
        mutationFn: async (payload) => {
            const { data } = await apiClient.requestPasswordReset(payload);
            return data;
        },
    });
